/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';// Importing createTimeline
import anime from 'animejs';// Importing createTimeline
import styled from 'styled-components';
import { IconLoader } from '@components/icons';

const StyledLoader = styled.div`
  ${({ theme }) => theme.mixins.flexCenter};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: var(--dark-navy);
  z-index: 99;

  .logo-wrapper {
    width: max-content;
    max-width: 100px;
    transition: var(--transition);
    opacity: ${props => (props.$isMounted ? 1 : 0)};
    
    svg {
      display: block;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      fill: none;
      user-select: none;

      #B {
        opacity: 0;
      }
    }
  }
`;

const Loader = ({ finishLoading }) => {
  const [isMounted, setIsMounted] = useState(false);

  const animate = () => {
  const timeline = anime.timeline({
    complete: () => finishLoading(),
  });

  
  timeline
    .add({
  targets: '#logo path',
  delay: 300,
  duration: 1500,
  easing: 'easeInOutQuart',
  strokeDashoffset: [anime.setDashoffset, 0], // Hexagon draw animation
})
.add({
  targets: '#logo #K',  // Targeting the K element
  duration: 700,
  easing: 'easeInOutQuart',
  opacity: [0, 1],  // Fade in the K after hexagon animation
  offset: '+=500',  // Delay K's animation until after the hexagon has drawn
})
.add({
  targets: '#logo',
  delay: 500,
  duration: 300,
  easing: 'easeInOutQuart',
  opacity: 0,
  scale: 0.1,  // Scale down the entire logo
  offset: '+=1000',  // Add delay to make it appear after the hexagon and K animation
})
.add({
  targets: '.loader',
  duration: 200,
  easing: 'easeInOutQuart',
  opacity: 0,
  zIndex: -1,
  offset: '+=1300',  // Wait for logo animation to finish before fading out the loader
});
};



 useEffect(() => {
  const timeout = setTimeout(() => {
    setIsMounted(true);
    animate();
  }, 100); // Slightly delay animation
  return () => clearTimeout(timeout);
}, []);


  return (
    <StyledLoader className="loader" $isMounted={isMounted}>
      <Helmet bodyAttributes={{ class: `hidden` }} />

      <div className="logo-wrapper">
        <IconLoader />
      </div>
    </StyledLoader>
  );
};

Loader.propTypes = {
  finishLoading: PropTypes.func.isRequired,
};

export default Loader;
